






import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Helpers
import { parseBase64 } from '@/helpers/image'

@Component
export default class ImageCanvasAnnotation extends Vue {
  isLoading: boolean = false
  imageSrc: string = null
  $refs: any

  @Getter('token') token
  @Prop() data

  mounted() {
    this.loadImage()
  }

  drawCanvas() {
    const ctx = this.$refs.canvas.getContext('2d')
    const img = new Image()

    img.onload = () => {
      ctx.imageSmoothingEnabled = true
      this.$refs.canvas.width = img.naturalWidth
      this.$refs.canvas.height = img.naturalHeight
      ctx.drawImage(img, 0, 0)
    }

    img.src = this.imageSrc
  }

  async loadImage() {
    if (!this.data && !this.data.value) {
      return
    }
    try {
      this.isLoading = true
      const res = await this.$api.image.getImageFromHash(this.token, this.data.value, false)
      this.imageSrc = parseBase64(res.data)
      this.drawCanvas()
      // this.$emit('loaded', this.imageSrc)
    } finally {
      this.isLoading = false
    }
  }
}
